import { EnrollmentStatusEntity } from "infrastructure/services/types/enrollments.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState = {
  enrollmentId: '',
  status: '',
  updatedAt: '',
} as EnrollmentStatusEntity;

export const enrollmentUserReducer = createSlice({
  name: "EnrollmentUserReducer",
  initialState,
  reducers: {
    saveBiometricEnrollmentUser: (state, action: PayloadAction<EnrollmentStatusEntity>) => {
      return action.payload;
    },
    resetBiometricEnrollmentUser: () => {
      return initialState;
    },
  },
});

export const { resetBiometricEnrollmentUser, saveBiometricEnrollmentUser } = enrollmentUserReducer.actions;

export const getBiometricEnrollmentUserRedux = (state: RootState) => { return state };

export const getBiometricEnrollmentUserStatus = (state: RootState) => { return state.enrollmentUserReducer.status };

export const getBiometricEnrollmentUserId = (state: RootState) => { return state.enrollmentUserReducer.enrollmentId };

export default enrollmentUserReducer.reducer;
